<template>
  <TMainForm :script-id="scriptId" :interception="interception" :buttons="buttons" :default-design="defaultDesign"
    ref="MainForm" :default-change-script="defaultChangeScript" :default-proccess-script="defaultProccessScript" />
</template>

<script setup>
/**
 * TTMGMSForm
 */
import TMainForm from './TMainForm.vue';
import { FORM_DESIGNS, FORM_CHANGE_SCRIPTS, FORM_PROCESS_SCRIPTS } from './constants';
import { ref, computed } from 'vue';
import { useStore } from 'vuex';

const store = useStore();

const props = defineProps({
  scriptId: { type: Number, default: null },
  interception: { type: Boolean, default: null },
});
const MainForm = ref(null);

const buttons = computed(() => [
  {
    key: 'SWITCH_FLANGE_DO_NUMBE',
    index: 15,
    name: 'ПСМ - переключить на следующий фланец',
    click: () => {
      if (!store) return;

      const SWITCH_MODE = MainForm.value?.propertyByName(
        store.getters.propertyAll,
        'SWITCH_MODE'
      );

      if (!SWITCH_MODE || SWITCH_MODE.outputValue?.value !== 0) {
        store.commit('SET_ERROR', {
          er: 'Переключение фланца возможно только в ручном режиме. Переключите ПСМ в ручной режим.',
          source: ['SWITCH_FLANGE_DO_NUMBE'],
        });
        return;
      }
      const SWITCH_FLANGE_DO_NUMBER = MainForm.value?.propertyByName(
        store.getters.propertyAll,
        'SWITCH_FLANGE_DO_NUMBER'
      );
      const SWITCH_FLANGE_NO = MainForm.value?.propertyByName(
        store.getters.propertyAll,
        'SWITCH_FLANGE_NO'
      );
      const flanges = store.getters.activeFlanges.sort((a, b) =>
        a.no > b.no ? 1 : b.no > a.no ? -1 : 0
      );
      if (SWITCH_FLANGE_NO && SWITCH_FLANGE_DO_NUMBER) {
        const flangeSw = SWITCH_FLANGE_NO.outputValue?.value;
        let flangeNoFirst = null;
        for (let i = 0; i < flanges.length; i++) {
          if (flangeSw < flanges[i].no && flanges[i].no !== 0) {
            return MainForm.value?.propertyWrite(
              {},
              [],
              SWITCH_FLANGE_DO_NUMBER,
              flanges[i].no
            );
          }
          if (flanges[i].no > 0 && !flangeNoFirst) flangeNoFirst = flanges[i].no;
        }
        if (flangeSw === flanges[flanges.length - 1].no && flangeNoFirst) {
          return MainForm.value?.propertyWrite(
            {},
            [],
            SWITCH_FLANGE_DO_NUMBER,
            flangeNoFirst
          );
        }
      } else {
        store.dispatch('addScriptLog', {
          message: 'SWITCH_FLANGE_DO_NUMBER не найден',
          facilityId: MainForm.value?.$route?.params?.facility_id,
        });

        store.commit('SET_ERROR', {
          er: 'SWITCH_FLANGE_DO_NUMBER не найден',
          source: ['TTMGMSForm', 'buttons'],
        });
      }
    },
  },
]);

const defaultDesign = FORM_DESIGNS.TTMGMSForm;
const defaultChangeScript = FORM_CHANGE_SCRIPTS.TTMGMSForm;
const defaultProccessScript = FORM_PROCESS_SCRIPTS.TTMGMSForm;
</script>
